import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import ArrowLeft from '../img/arrow-left.svg';
import ArrowRight from '../img/arrow-right.svg';
import ActivityList from './components/activity-list';
import './index.less';
const prefixCls = 'yx-calendar';

const Calendar = ({ rangeMode = true }) => {
  const [currentDate, setCurrentDate] = useState(moment());
  const [isInThisMonth, setIsInThisMonth] = useState(true);

  const changeMonth = (type) => {
    setCurrentDate((date) => moment(date)[type](2, 'M'));
  };

  const backToCurrentMonth = () => {
    if (isInThisMonth) return;
    setCurrentDate(moment());
  };

  const currentDateRangeObj = useMemo(() => {
    const cloneCurrentDate = moment(currentDate);
    const nextDate = moment(cloneCurrentDate).add(1, 'M');
    const currentRangeStr = `${cloneCurrentDate.format('YYYY/MM')}-${nextDate.format('YYYY/MM')}`;

    return {
      currentRangeStr,
      currentYearAndMonthStr: cloneCurrentDate.format('YY年MM月'),
      currentDateStr: cloneCurrentDate.format('MM'),
      startDate: moment(currentDate).startOf('M'),
      endDate: moment(nextDate).endOf('M'),
      nextYearAndMonthStr: nextDate.format('YY年MM月'),
      nextDateStr: nextDate.format('MM'),
    };
  }, [currentDate]);
  useEffect(() => {
    if (currentDate.format('YYYY/MM') === moment().format('YYYY/MM')) {
      setIsInThisMonth(true);
    } else {
      setIsInThisMonth(false);
    }
  }, [currentDate]);

  return (
    <div className={prefixCls}>
      <div className={`${prefixCls}-date-header`}>
        <div
          className={`${prefixCls}-date-picker-back ${!isInThisMonth && 'highlight'}`}
          onClick={() => backToCurrentMonth()}
        >
          回到本月
        </div>
        <div className={`${prefixCls}-date-picker`}>
          <div style={{ margin: '0 6px' }} className={`${prefixCls}-date-picker-change-icon-container`}>
            {!isInThisMonth ? (
              <img src={ArrowLeft} onClick={() => changeMonth('subtract')} />
            ) : (
              <img style={{ opacity: '.3' }} src={ArrowLeft} />
            )}
          </div>
          <div className={`${prefixCls}-date-picker-change-icon-container`}>
            <img src={ArrowRight} onClick={() => changeMonth('add')} />
          </div>
        </div>
      </div>
      <div className={`${prefixCls}-content`}>
        <div className="yx-calendar-content-divider"></div>
        <div className={`${prefixCls}-content-date`}>
          <div className={`${prefixCls}-content-date-left`}>
            <span>{currentDateRangeObj.currentYearAndMonthStr}</span>
          </div>
          <div className={`${prefixCls}-content-date-right`}>
            <span>{currentDateRangeObj.nextYearAndMonthStr}</span>
          </div>
        </div>
        <ActivityList
          startDate={currentDateRangeObj.startDate}
          rangeMode={rangeMode}
          endDate={currentDateRangeObj.endDate}
        />
      </div>
    </div>
  );
};

export default React.memo(Calendar);
